/* Saduq Care × السلطان عمر — card size pills + small home helpers. No dependencies. */
(function () {
  'use strict';

  /* ---------- product card: size pills (ported from live data-sl-cv) ----------
     Switches the variant id posted by the card's ajax form (theme.js handles the add),
     the price / compare price, the savings badge and the free-shipping chip. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sc-v]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var card = b.closest('[data-sc-card]');
    if (!card) return;
    card.querySelectorAll('[data-sc-v]').forEach(function (x) {
      var on = x === b;
      x.classList.toggle('is-on', on);
      x.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var id = card.querySelector('[data-sc-id]');
    if (id) id.value = b.getAttribute('data-sc-v');

    var price = card.querySelector('[data-sc-price]');
    if (price) {
      var html = '<span class="price">' + b.getAttribute('data-price') + '</span>';
      if (b.hasAttribute('data-compare')) html += '<s class="price-compare">' + b.getAttribute('data-compare') + '</s>';
      price.innerHTML = html;
    }
    var save = card.querySelector('[data-sc-save]');
    if (save) {
      if (b.hasAttribute('data-save')) { save.textContent = 'وفّر ' + b.getAttribute('data-save'); save.hidden = false; }
      else save.hidden = true;
    }
    var ship = card.querySelector('[data-sc-ship]');
    var th = window.theme && window.theme.freeShipping;
    if (ship && th) ship.hidden = !(+b.getAttribute('data-cents') >= th);

    var atc = card.querySelector('.btn--atc[type=submit]');
    if (atc) atc.disabled = false;
  });
})();
